import React, { Component } from 'react'
import { Async } from 'react-select'
import { injectIntl } from 'react-intl'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'

function loadProducts(integrationKey) {
    return async (input, callback) => {
        const endpoint = 
            `/external-products-search/${integrationKey}?searchKeywords=${input}&limit=10`
        const products = await AppContext.getApiClient().get(endpoint)
        const options = products.data.map(x => createProductOption(x))
        callback(null, {
            options: options,
            complete: false,
        })
    }
}

function createProductOption(product) {
    if(!product) { return }

    return {
        value: product.externalId,
        label: product.title,
        product: product,
    }
}

class ProductSearchSelect extends Component {
    render() {
        const integrationKey = this.props.integrationKey
        const selectedOption = createProductOption(this.props.product)
        const callback = this.props.callback
        return (
            
            <div className={"form-group row"}>
                {this.props.label}
                <div className={"col-" + this.props.colSize}>
                    <Async
                        cache={false}
                        value={selectedOption}
                        onChange={option => callback(option.product)}
                        loadOptions={ loadProducts(integrationKey) }
                    />
                </div>
            </div>
        )
    }
}

export default injectIntl(ProductSearchSelect)


// WEBPACK FOOTER //
// ./src/settings/fees/productsearchselect.component.jsx